export default function MatrixView({ medications, interactions }) {
  // Mapa inline de colores de fondo semitransparentes
  const bgColors = {
    mild:     'rgba(255,217,102,0.3)',   // leve
    moderate: 'rgba(244,152,77,0.3)',    // moderada
    severe:   'rgba(231,76,60,0.3)'      // grave
  };

  const findInt = (a, b) =>
    interactions.find(i =>
      (i.source === a && i.target === b) ||
      (i.source === b && i.target === a)
    );

  return (
    <div className="bg-white rounded shadow-sm p-4 h-100 overflow-auto">
      <h6>Matriz de Interacciones</h6>
      <table className="table table-bordered table-sm mt-2 mb-0">
        <thead className="table-light">
          <tr><th></th>
            {medications.map(m => (
              <th key={m.id} className="text-center align-middle">{m.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {medications.map(row => (
            <tr key={row.id}>
              <th className="table-light text-center">{row.name}</th>
              {medications.map(col => {
                if (row.id === col.id) return <td key={col.id}></td>;
                const ix = findInt(row.id, col.id);
                return (
                  <td
                    key={col.id}
                    style={{
                      backgroundColor: ix
                        ? bgColors[ix.severity]
                        : 'transparent'
                    }}
                  >
                    {ix ? ix.description : 'Sin interacción conocida'}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}